// src/api/payments.js

import api from "./axios";

export async function createCheckoutSession(payload) {
  const { data } = await api.post(`/payments/checkout/session`, payload);
  return data; // { id }
}

export async function createReservationSession(payload) {
  const { data } = await api.post(`/payments/checkout/reserve`, payload);
  return data; // { id }
}

export async function fetchOrderBySession(sessionId) {
  const { data } = await api.get(`/payments/orders/by-session/${sessionId}`);
  return data;
}
